(function () {
  function initLinkedOptions(container) {
    if (!container) return;

    var variantsElement = container.querySelector('[data-linked-variants]');
    if (!variantsElement) return;

    var variants;

    try {
      variants = JSON.parse(variantsElement.textContent);
    } catch (error) {
      console.error('Linked options: invalid variant JSON', error);
      return;
    }

    function getControls(position) {
      return Array.from(
        container.querySelectorAll('[name="option' + position + '"]')
      );
    }

    function getSelected(position) {
      var controls = getControls(position);

      if (!controls.length) return null;

      if (controls[0].tagName === 'SELECT') {
        return controls[0].value;
      }

      var checked = controls.find(function (control) {
        return control.checked;
      });

      return checked ? checked.value : null;
    }

    function combinationExists(position, value) {
      return variants.some(function (variant) {

        if (variant.options[position - 1] !== value) {
          return false;
        }

        for (var previous = 1; previous < position; previous++) {

          var selected = getSelected(previous);

          if (
            selected &&
            variant.options[previous - 1] !== selected
          ) {
            return false;
          }
        }

        return true;
      });
    }

    function updateOption(position) {
      var controls = getControls(position);

      if (!controls.length) return;

      /* DROPDOWN */
      if (controls[0].tagName === 'SELECT') {

        var select = controls[0];

        Array.from(select.options).forEach(function (option) {

          var valid = combinationExists(
            position,
            option.value
          );

          option.hidden = !valid;
          option.disabled = !valid;

          if (valid) {
            option.style.display = '';
          } else {
            option.style.display = 'none';
          }
        });

        var selected =
          select.options[select.selectedIndex];

        if (!selected || selected.disabled) {

          var firstValid =
            Array.from(select.options).find(
              function (option) {
                return !option.disabled;
              }
            );

          if (firstValid) {

            select.value = firstValid.value;

            select.dispatchEvent(
              new Event('change', {
                bubbles: true
              })
            );
          }
        }

        return;
      }

      /* BUTTONS / SWATCHES */

      controls.forEach(function (input) {

        var valid =
          combinationExists(position, input.value);

        var wrapper =
          input.closest('.radio-option') ||
          input.closest('.radio-container') ||
          input.parentElement;

        if (wrapper) {
          wrapper.style.display =
            valid ? '' : 'none';
        }
      });

      var selectedInput =
        controls.find(function (input) {
          return input.checked;
        });

      if (
        !selectedInput ||
        !combinationExists(
          position,
          selectedInput.value
        )
      ) {

        var firstValidInput =
          controls.find(function (input) {
            return combinationExists(
              position,
              input.value
            );
          });

        if (firstValidInput) {

          firstValidInput.checked = true;

          firstValidInput.dispatchEvent(
            new Event('change', {
              bubbles: true
            })
          );
        }
      }
    }

    function refresh() {

      /*
       * Always recalculate both dependent levels
       * from the CURRENT selections.
       */

      updateOption(2);
      updateOption(3);
    }

    /*
     * Install event listener only once.
     */

    if (!container.dataset.linkedOptionsListener) {

      container.dataset.linkedOptionsListener = 'true';

      container.addEventListener(
        'change',
        function (event) {

          if (
            !event.target.matches(
              '[name^="option"]'
            )
          ) {
            return;
          }

          /*
           * Ultra processes the variant first.
           * Then we filter again.
           */

          setTimeout(refresh, 50);
          setTimeout(refresh, 250);
          setTimeout(refresh, 500);
        }
      );
    }

    refresh();
  }


  function refreshAll() {

    document
      .querySelectorAll('.js-product-options')
      .forEach(function (container) {

        initLinkedOptions(container);

      });
  }


  /*
   * Initial page load
   */

  document.addEventListener(
    'DOMContentLoaded',
    function () {

      setTimeout(refreshAll, 100);

    }
  );


  /*
   * Shopify Theme Editor
   */

  document.addEventListener(
    'shopify:section:load',
    function () {

      setTimeout(refreshAll, 100);

    }
  );


  /*
   * Watch for Ultra replacing/updating
   * the product option HTML.
   */

  var observer =
    new MutationObserver(function (mutations) {

      var productOptionsChanged = false;

      mutations.forEach(function (mutation) {

        if (
          mutation.target.closest &&
          mutation.target.closest(
            '.js-product-options'
          )
        ) {
          productOptionsChanged = true;
        }

      });

      if (productOptionsChanged) {

        clearTimeout(
          window.linkedOptionsRefreshTimer
        );

        window.linkedOptionsRefreshTimer =
          setTimeout(refreshAll, 50);
      }
    });


  document.addEventListener(
    'DOMContentLoaded',
    function () {

      observer.observe(
        document.body,
        {
          childList: true,
          subtree: true
        }
      );

    }
  );

})();